import React, { ReactNode } from "react";

import _ from "lodash";
import cx from "classnames";
import styles from './style.module.scss';

interface TruncateProps {
  width?: number;
  lines?: number;
  className?: string;
  children: ReactNode;
}

const Truncate: React.FC<TruncateProps> = ({ width = 300, lines = 1, className, children }) => {
  return (
    <span style={{ maxWidth: width }} className={cx(styles.truncate, className)}>
      {children}
    </span>
  );
};

export default Truncate;
